import { TargetingTagScore } from '@moojo/agent-worker-api'
import { Card } from '@moojo/card-definition-catalog'
import { Instant } from '@moojo/duration'
import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

/**
 * User is identified by a bearer token (Authorization header)
 */
export const GetUserProfileRequest = z.record(z.string(), z.never())

export type GetUserProfileRequest = z.infer<typeof GetUserProfileRequest>

export const GetUserProfileResponse = z.object({
  targetingTagScores: TargetingTagScore.array(),
  cards: Card.extend({ modifiedAt: Instant.zod() }).array(),
})

export type GetUserProfileResponse = z.infer<typeof GetUserProfileResponse>

export const getUserProfileDeclaration = endpointDeclaration(GetUserProfileRequest, GetUserProfileResponse)
